import { render, staticRenderFns } from "./myCS1.vue?vue&type=template&id=0963b5e4&scoped=true&"
import script from "./myCS1.vue?vue&type=script&lang=js&"
export * from "./myCS1.vue?vue&type=script&lang=js&"
import style0 from "./myCS1.vue?vue&type=style&index=0&id=0963b5e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0963b5e4",
  null
  
)

export default component.exports